import { useEffect, useRef, useState } from "react";

import { getTeams } from "../services/teams.api";

/*
  Registration codes for a campaign's teams.

  Fetched lazily the first time the codes modal is opened, then cached
  for the life of the dashboard — codes do not change during an event,
  and the dashboard otherwise runs untouched for hours on a TV.
*/
export default function useTeamCodes(campaignId, isOpen) {
  const [teams, setTeams] = useState(null);
  const [error, setError] = useState(false);
  const requestedRef = useRef(false);

  useEffect(() => {
    if (!isOpen || !campaignId || requestedRef.current) return;

    requestedRef.current = true;
    let cancelled = false;

    (async () => {
      try {
        const response = await getTeams(campaignId);
        if (cancelled) return;

        setTeams(response.data || response);
      } catch (err) {
        if (cancelled) return;

        console.log("TEAM CODES ERROR:", err);
        setError(true);
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [campaignId, isOpen]);

  return { teams, error };
}
